import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getCategoriesData(context) {
      const response = await Vue.axios.get(`${URL_API}category`);
      let data = response["data"];
      context.commit("updateCategoriesData", data);
    },
    async createCategoryData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}category/store`, body, config);
      context.dispatch("getCategoriesData");
    },
    async pushCategoryData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}category/update`, body, config);
      context.dispatch("getCategoriesData");
    },
    async destroyCategoryData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}category/destroy`, body, config);
      context.dispatch("getCategoriesData");
    }
  },
  mutations: {
    updateCategoriesData(state, categoriesData) {
      state.categoriesData = categoriesData;
    }
  },
  state: {
    categoriesData: []
  },
  getters: {
    allCategoriesData(state) {
      return state.categoriesData;
    }
  }
};
